import { render, staticRenderFns } from "./ProfilesTableUser.vue?vue&type=template&id=ee90f5a4&scoped=true"
import script from "./ProfilesTableUser.vue?vue&type=script&lang=js"
export * from "./ProfilesTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee90f5a4",
  null
  
)

export default component.exports